import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box } from '@material-ui/core';
import PropTypes from 'prop-types';

import { AsyncSpeciesSelector } from 'src/components/inputs';
import { utils } from 'src/utils';


const AssociationDialog = ({ open, onCloseDialog, onConfirm, eeccSpecies, searchController }) => {
  const [ speciesSelected, setSpeciesSelected ] = useState();
  const realClose = () => {
    onCloseDialog();
    setSpeciesSelected();
  };

  return <Dialog open={ open } onClose={ realClose } aria-labelledby="association-modal-title">
    <DialogTitle id="association-modal-title">
      Asociar a { '"' }<Box component="span" fontStyle="italic">{ utils.upperFirst(eeccSpecies.scientificName || '') }</Box>{ '"' }
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        Usa el buscador para encontrar la especie a la cual quieres vincular la categoría de conservación
        <strong> { eeccSpecies.validCategory }</strong>.<br/>
        Las especies que ya tienen una categoría de conservación estarán <strong>deshabilitadas</strong>, debes des-asociarlas
        antes si quieres volver a asociarlas.<br/>
        La búsqueda se efectúa dentro del nombre científico y sinonimias disponibles.
      </DialogContentText>
      <AsyncSpeciesSelector maxResults={ 30 } onSelect={ s => setSpeciesSelected(s) } searchController={ searchController } />
    </DialogContent>
    <DialogActions>
      <Button onClick={ realClose } color="primary">
        Cancelar
      </Button>
      <Button disabled={ !speciesSelected } onClick={ () => onConfirm(speciesSelected) } color="primary">
        Asociar
      </Button>
    </DialogActions>
  </Dialog>;
};

AssociationDialog.propTypes = {
  open: PropTypes.bool,
  onCloseDialog: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  eeccSpecies: PropTypes.object,
  searchController: PropTypes.func.isRequired,
};

export { AssociationDialog };